import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    name: { label: i18n.t('app.name'), value: '' }
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'idEstado', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'idEstado', title: i18n.t('app.name'), format: '["TIPOS_ESTADO", "TIPOS_ESTADO_RECEPCION","TIPOS_ESTADO_VERIFACTU"]', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
  ] 
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
